import { bannerGridType, mediaType } from "@/apiUtils/constants";
import { BannerGridMediaTile } from "@/common/lib/types";
import { LinkContent } from "@/utils/common";
// import Image from "next/image";
import Image from "@/components/ui/imageV2/ImageV2";
import { CLink } from "../customLink/CustomLink";
import VideoCard from "../videoCard/VideoCard";
import { cn } from "@/lib/tailwind";
import NoImageSrc from "@/assets/images/no_image.svg";
import { getCloudinaryURL } from "@/utils/cloudinary";
interface IProps {
  content: BannerGridMediaTile;
  link?: LinkContent;
  bannerType: string;
  title?: string;
  isGridImages?: boolean;
  isPDP?: boolean
}
const MediaTile = ({ bannerType, content, link, title, isGridImages, isPDP }: IProps) => {

  const getDesktopHeight = (bannerType: string, isGridImages?: boolean, isPDP?: boolean) => {
    if (isGridImages) return "h-[720px]";
    if (bannerType === bannerGridType.LARGE) return isPDP ? "h-[567px]" : "h-[720px]";
    return isPDP ? "h-[412px]" : "h-[540px]";
  };

  const getMobileHeight = (bannerType: string, isPDP?: boolean) => {
    if (bannerType === bannerGridType.LARGE) return isPDP ? "h-[500px]" : "h-[512px]";
    return isPDP ? "h-[300px]" : "h-[370px]";
  };
  return (
    <>
      {content?.mediaType === mediaType.IMAGE ? (
        <div className="h-full w-full">
          <CLink href={link?.url ?? "/"}>
            {/* desktop screen */}
            <Image
              src={getCloudinaryURL(content?.media?.largeMediaUrl) ?? NoImageSrc}
              width={720}
              height={bannerType === bannerGridType.LARGE ? 720 : 540}
              alt={title ?? "Banner grid"}
              className={cn(
                "hidden h-full w-full object-cover md:block",
                getDesktopHeight(bannerType, isGridImages, isPDP),
              )}
            />

            {/* mobile screen */}
            <Image
              src={getCloudinaryURL(content?.media?.smallMediaUrl) ?? NoImageSrc}
              width={375}
              height={bannerType === bannerGridType.LARGE ? 512 : 370}
              alt={title ?? "Banner grid"}
              className={cn(
                "h-full w-full object-cover md:hidden",
                getMobileHeight(bannerType, isPDP),
              )}
            />
          </CLink>
        </div>
      ) : (
        <></>
      )}
      {content?.mediaType === mediaType.VIDEO ? (
        <>
          <VideoCard
            videoProps={{
              // autoPlay: true,
              muted: true,
              src: content?.media?.largeMediaUrl,
              poster: content?.videoThumbnail?.largeMediaUrl,
              loop: content?.loop,
              className: "h-full w-full object-cover ",
              title: title,
            }}
            containerProps={{
              className: `hidden h-full w-full md:block ${getDesktopHeight(bannerType, isGridImages, isPDP)}`,
            }}
            showControls={content?.showControls}
            url={link?.url}
          />
          <VideoCard
            videoProps={{
              // autoPlay: true,
              muted: true,
              src: content?.media?.smallMediaUrl,
              poster: content?.videoThumbnail?.smallMediaUrl,
              loop: content?.loop,
              className: "h-full w-full object-cover",
            }}
            containerProps={{
              className: `md:hidden h-full w-full ${getMobileHeight(bannerType, isPDP)}`,
            }}
            url={link?.url}
            showControls={content?.showControls}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default MediaTile;
